export default __webpack_public_path__ + "static/media/trhreecard.791f1540.png";